const CalismaRuhsat = resolve => {
    require.ensure(['../views/apps/calismaRuhsat/CalismaRuhsat'], () => {
        resolve(require('../views/apps/calismaRuhsat/CalismaRuhsat'))
    })
};
const CalismaRuhsatTanimla = resolve => {
    require.ensure(['../views/apps/calismaRuhsat/CalismaRuhsatTanimla'], () => {
        resolve(require('../views/apps/calismaRuhsat/CalismaRuhsatTanimla'))
    })
};
const CalismaRuhsatListesi = resolve => {
    require.ensure(['../views/apps/calismaRuhsat/CalismaRuhsatListesi'], () => {
        resolve(require('../views/apps/calismaRuhsat/CalismaRuhsatListesi'))
    })
};
const CalismaRuhsatGuncelle = resolve => {
    require.ensure(['../views/apps/calismaRuhsat/CalismaRuhsatGuncelle'], () => {
        resolve(require('../views/apps/calismaRuhsat/CalismaRuhsatGuncelle'))
    })
};


import layouts from '../layout'
import Vue from 'vue'

Vue.component('acmave-calisma-ruhsat-tanimla', CalismaRuhsatTanimla);
Vue.component('acmave-calisma-ruhsat-listesi', CalismaRuhsatListesi);
Vue.component('acmave-calisma-ruhsat-guncelle', CalismaRuhsatGuncelle);


export default {
    path: '/calismaruhsat',
    name: 'calismaruhsat',
    component: CalismaRuhsat,
    meta: {
        layout: layouts.navLeft
    }

}